import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Session } from 'src/app/models/session';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-nueva-solicitud-de-reppuestos',
  templateUrl: './nueva-solicitud-de-reppuestos.component.html',
  styleUrls: ['./nueva-solicitud-de-reppuestos.component.css']
})
export class NuevaSolicitudDeReppuestosComponent implements OnInit {

  
  constructor(private session: Session, private service: UserService,private activeModal: NgbActiveModal, private userService: UserService, private toast: ToastrService) { }

  @Input()
  fijos = [];
  
  repuestos = [];

  selectedTecnico;

  productos = [];
  selectedProducto;
  selectedRepuesto;
  selectedCantidad = 1;

  nuevos = [];

  tecnicos = [];
  zonas = [];

  tecnico;
  selectedProvincia;
  selectedLocalidad;

  provincias = [];
  getProvincias(){
    for(let z of this.zonas){
      if(this.provincias.indexOf(z.provincia)<0) this.provincias.push(z.provincia);
    }
    this.provincias.sort( (a,b) => { return a > b ? 1 : -1 });
    this.selectedProvincia = this.provincias[0];
    
    this.getLocalidades();
  }

  localidades = [];
  getLocalidades(){
    this.tecnico = null;
    this.localidades = [];
    for(let z of this.zonas){
      if(this.selectedProvincia==z.provincia && this.localidades.indexOf(z.localidad)<0) this.localidades.push(z.localidad);
    }
    this.localidades.sort( (a,b) => { return a > b ? 1 : -1 });
    this.selectedLocalidad = this.localidades[0];
    this.getTecnicosZona()
  }

  tecnicosZona = [];
  getTecnicosZona(){
    this.tecnico = null;
    let ret = [];
    for(let t of this.tecnicos){
      for(let z of t.zonas){
        if(z.provincia == this.selectedProvincia && z.localidad == this.selectedLocalidad){
          ret.push(t);
          break;
        }
      }
    }
    
    this.tecnicosZona = ret;
  }


  ngOnInit() {

    this.service.getTecnicos().subscribe(d=>{
      this.tecnicos = d.filter(x=> x.isAvailable==true);
      this.tecnicos.forEach( t =>{
        t.zonas.forEach( z=>{
          this.zonas.push(z);
        });
        this.getProvincias();
      });
    })

    if(this.session.repuestos.length<1){
      this.service.getProductos().subscribe(d=>{
        this.session.productos = d.productos;
        this.productos = d.productos;
        this.productos.sort( (a,b) => { return a.barcode > b.barcode ? 1 : -1 });
      })
    }
    else this.productos = this.session.productos;

  }

  flash = -1;
  agregar(){
    this.flash = -1;
    if(this.selectedCantidad<1) return;
    let index = this.nuevos.findIndex(x=> x._id == this.selectedRepuesto._id);
    if(index >=0){
      return this.flash = index;
    }
    let repuesto = this.selectedRepuesto;
    let cantidad = this.selectedCantidad;
    let add = { cantidad: cantidad, _id: repuesto._id, nombre: repuesto.nombre, };
    console.log(JSON.stringify(this.selectedRepuesto));
    console.log(add);
    
    this.nuevos.push(add);
  }


  remove(i){
    this.nuevos.splice(i,1);
  }


  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {

    this.userService.nuevaSolicitudRepuestos(this.tecnico, this.nuevos).subscribe(d=>{
      this.activeModal.close({ tecnico: this.tecnico,nuevos: this.nuevos });
    }, er=> this.toast.error("ERROR"));

  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  getRepuestos(){
    this.service.getProductRepuestos(this.selectedProducto.codigo).subscribe(d=>{
      this.repuestos = d.repuestos.map( x=> { return { nombre: x.nombre, _id: x.codigo}});
      this.repuestos.sort( (a,b) => { return a.nombre > b.nombre ? 1 : -1 });
    });
  }
}
